module.exports = __webpack_public_path__ + "img/defaultImg.18b08668.svg";